var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SearchBannerFormItem",
    {
      staticClass: "form-item-amount-dropdown",
      attrs: {
        id: _vm.id,
        label: _vm.label,
        "store-namespace": _vm.storeNamespace,
        "drawer-config": _vm.drawerConfig,
        "display-value": _vm.displayValue,
        active: _vm.isActive,
        "is-desktop": _vm.isDesktop,
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
        close: function ($event) {
          return _vm.$emit("close", $event)
        },
      },
    },
    [
      _c(
        "ol",
        _vm._l(_vm.options, function (option) {
          return _c("li", { key: option.value }, [
            _c(
              "button",
              {
                class: { active: option.value === _vm.value },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.handleSelect(option.value)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(option.label) + "\n      ")]
            ),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }